module.exports = __webpack_public_path__ + "assets/img/hz.23bae3fb.png";